import { AxiosResponse } from 'axios';
import { PAGE_SIZE } from '~/constants';
import {
  EquipmentModel,
  EquipmentModelForm,
  EquipmentModelView,
  Pagination,
  SelectItem,
} from '~/types';
import api from '~/utils/api';
import { formatInTimeZone } from '~/utils/formatToTimeZone';

export async function getEquipmentModels(
  page: number,
  search: string,
): Promise<Pagination<EquipmentModelView>> {
  const { data } = await api.get<Pagination<EquipmentModel>>(
    '/modeloequipamento',
    {
      params: {
        page,
        size: PAGE_SIZE,
        ...(search ? { search } : {}),
      },
    },
  );

  const equipmentModels = data.results.map(model => ({
    ...model,
    formattedInitialDate: formatInTimeZone(
      model.dh_ultimaatualizacao,
      'dd/MM/yyyy',
    ),
    formattedStatus: model.tp_situacao === '1' ? 'ATIVO' : 'INATIVO',
    colorScheme: model.tp_situacao === '1' ? 'green' : 'red',
    status: model.tp_situacao === '1',
  }));

  return {
    ...data,
    results: equipmentModels,
  };
}

export async function updateEquipmentModelById(
  id: string,
  data: EquipmentModelForm,
): Promise<AxiosResponse<any>> {
  return api.put(`/modeloequipamento/${id}`, data);
}

export async function createEquipmentModel(
  data: EquipmentModelForm,
): Promise<AxiosResponse<any>> {
  return api.post(`/modeloequipamento`, data);
}

export async function getEquipmentModelsAsSelect(): Promise<SelectItem[]> {
  const responses: SelectItem[] = [];

  return new Promise((resolve, rejects) => {
    async function getData(page: number) {
      return api
        .get<Pagination<EquipmentModel>>('/modeloequipamento', {
          params: {
            page,
            size: PAGE_SIZE,
          },
        })
        .then(response => {
          const options = response.data.results
            .filter(model => model.tp_situacao === '1')
            .map(model => ({
              label: model.nm_modeloequipamento || '-',
              value: String(model.id_modeloequipamento),
            }));
          responses.push(...options);

          if (response?.data.next) {
            getData(page + 1);
            return response;
          }
          return resolve(responses);
        })
        .catch(() => {
          return rejects(responses);
        });
    }
    getData(1);
  });
}
